export default "__VITE_ASSET__ebe4a733__"